export default "__VITE_ASSET__34060819__"